import { useFormikContext } from 'formik';
import { OfferType } from 'legacy/events/types';
import { useState } from 'react';
import TierSelectionModal from '../TierSelectionModal';
import TierSelection from '../TierSelection';

const EligibleTiers = () => {
  const { values, setFieldValue } = useFormikContext<OfferType>();
  const [showTicketTierModal, setShowTicketTierModal] = useState(false);
  const saleConditions = values.rewards.kickbackRewards.saleConditions;
  const tiers = saleConditions.tiers || [];

  return (
    <div className="mt-4">
      <div className="text-xs font-bold text-[#575757] mb-2 leading-[14px]">
        Select eligible ticket tiers
      </div>
      <TierSelection
        tiers={tiers}
        handleOnPress={() => setShowTicketTierModal(true)}
      />
      {showTicketTierModal && (
        <TierSelectionModal
          tiers={saleConditions.tiers || []}
          onClose={() => setShowTicketTierModal(false)}
          onSubmit={(tiers) => {
            setFieldValue(
              'rewards.kickbackRewards.saleConditions.tiers',
              tiers
            );
            setShowTicketTierModal(false);
          }}
        />
      )}
    </div>
  );
};

export default EligibleTiers;
